export default {
  name: 'marking--reportStatus',
};